var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 45,
    viewBox: "0 0 66 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.7499,
    y: 24.9998,
    width: 7.5,
    height: 24.1667,
    transform: "rotate(90 58.7499 24.9998)",
    fill: "#834FF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4167,
    y: 37.4998,
    width: 7.5,
    height: 13.3333,
    transform: "rotate(90 65.4167 37.4998)",
    fill: "#BFA1FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5833,
    y: 12.4999,
    width: 7.5,
    height: 45.8333,
    transform: "rotate(90 54.5833 12.4999)",
    fill: "#3D00C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9999,
    y: -0.00012207,
    width: 7.5,
    height: 40,
    transform: "rotate(90 39.9999 -0.00012207)",
    fill: "#23006E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionTimeline);
export default __webpack_public_path__ + "static/media/Action_timeline.d540bac4294578370dad89db94fb9968.svg";
export { ForwardRef as ReactComponent };